"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectoryAndOfferDetailsModal = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const i18n_js_1 = __importDefault(require("i18n-js"));
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const Place_1 = __importDefault(require("@mui/icons-material/Place"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const KeyboardDoubleArrowDown_1 = __importDefault(require("@mui/icons-material/KeyboardDoubleArrowDown"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const ContentCopy_1 = __importDefault(require("@mui/icons-material/ContentCopy"));
const OpenInNew_1 = __importDefault(require("@mui/icons-material/OpenInNew"));
const withStore_1 = __importDefault(require("../../../../common/decorators/withStore"));
const globalVariables_1 = require("../../../../common/globalVariables");
const CallToActionsInModal_1 = __importDefault(require("../../Detail/CallToActionsInModal"));
const BookingForm_1 = __importDefault(require("../../Booking/BookingForm"));
const Map_1 = __importDefault(require("../../Pages/Map"));
const DocumentDetail_1 = __importDefault(require("../../Detail/DocumentDetail"));
const WebsiteDetail_1 = __importDefault(require("../../Detail/WebsiteDetail"));
const VideoPlayer_1 = __importDefault(require("../../../../common/components/Other/VideoPlayer"));
const ShoppingCartRedesign_1 = __importDefault(require("../../ShoppingCart/ShoppingCartRedesign"));
const BookingLinkoutView_1 = __importDefault(require("./BookingLinkoutView"));
const CallToActionArea_1 = __importDefault(require("../../../../common/components/CallToActions/CallToActionArea"));
const ActivityListItem_1 = require("../../Other/ActivityListItem");
const helpers_1 = require("../../../../common/helpers/helpers");
const ItemDetailModalContentWrapper = styled_components_1.default.div `
  --lateral-padding: 16px;

  height: 100%;
  bottom: 0;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;

  &.document-modal {
    .image-container {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      background-color: black;

      img {
        width: 100%;
      }
    }
  }

  .snackbar {
    position: absolute;
    bottom: 8px;
  }

  .description-content {
    padding: 12px 0 0;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    background-color: #fff;

    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    overflow-y: auto;
  }

  .scrollable-content {
    width: 100%;
    flex-grow: 1;
    height: 300px;
    overflow-y: auto;
    padding-inline: var(--lateral-padding);
  }

  .title {
    margin-bottom: 8px;
    padding-inline: var(--lateral-padding);
  }

  .document-page {
    height: auto;
    width: 100%;
  }

  .website-page {
    height: auto;
    width: 100%;
  }

  .call-to-action-detail {
    margin-top: 16px;
    width: auto;

    .secondary-text {
      font-size: 1rem;
    }

    .main-text {
      font-size: 1rem;
    }

    canvas {
      width: 200px !important;
      height: 200px !important;

      border: 10px solid #fff;
    }
  }

  .statuses-location-wrapper {
    margin: 12px 0;
    display: flex;
    align-items: center;

    svg {
      height: 1rem;
    }
  }

  .dev-btn {
    margin: 20px 0;
  }

  .navigation {
    width: 100%;
    header {
      position: relative;
    }
  }

  .call-to-actions {
    width: 100%;

    .call-to-action-icon {
      width: 36px;
      height: 36px;

      svg {
        width: 20px;
        height: 20px;
      }
    }
  }

  .collapse-btn,
  .copy-btn,
  .open-btn {
    cursor: pointer;
    z-index: 12;
    position: absolute;
    top: 12px;
    background-color: #fff;
    opacity: 0.75;

    &:hover {
      opacity: 1;
      background-color: #fff;
    }

    &.dark {
      color: #fff;
      background-color: #808080;
    }
  }

  .location-and-availability {
    display: flex;
    align-items: center;
    gap: 25px;
  }
`;
const ContentTitle = styled_components_1.default.div `
  margin: 0;
`;
const LocationComp = styled_components_1.default.div `
  display: flex;
  color: #807e7e;
  margin-right: 16px;

  svg {
    position: relative;
    top: 2px;
  }

  span {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;
const Description = styled_components_1.default.div `
  color: rgba(0, 0, 0, 0.87);
  letter-spacing: 0.25px;
  width: 100%;
  font-size: 1rem; // body1

  ul {
      padding: revert;
      list-style-type: initial;
      
      & > li {
          list-style-type: initial;
      }
  }

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.5);
    box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  }
`;
const BookBtn = styled_components_1.default.p `
  position: sticky;
  bottom: 0;
  width: 100%;
  background-color: #fff;
  padding: 16px;
  margin: 0;
  border-top: 2px solid rgba(0, 0, 0, 0.1);
  button {
    width: 100%;
  }
`;
const ImageWrapper = styled_components_1.default.div `
  height: 30vh;
  @media (min-width: 600px) {
    height: 35vh;
  }
  @media (min-width: 1024px) {
    height: 30vh;
  }

  transition: height ${(props) => props.expansionDuration / 1000}s;

  &.hidden-img {
    height: 0px;
  }
`;
const ItemImage = styled_components_1.default.div `
  height: calc(30vh + 25px);
  @media (min-width: 600px) {
    height: calc(35vh + 25px);
  }
  @media (min-width: 1024px) {
    height: calc(30vh + 25px);
  }

  width: 100%;
  flex-shrink: 0;
  transition: height ${(props) => props.expansionDuration / 1000}s;

  &.hidden-img {
    height: 0px;
  }

  background: linear-gradient(
    5deg,
    ${(props) => props.theme.palette.mainAppColor.main} 0%,
    ${(props) => props.theme.palette.mainAppColor.light} 11%,
    ${(props) => props.theme.palette.mainAppColor.dark} 100%
  );
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  background-image: ${(props) => {
    if (props.src) {
        return props.src;
    }
    return null;
}};
`;
const VideoWrapper = styled_components_1.default.div `
  height: 30vh;
  @media (min-width: 600px) {
    height: 35vh;
  }
  @media (min-width: 1024px) {
    height: 30vh;
  }

  position: relative;
  background-color: #000;
  transition: height ${(props) => props.expansionDuration / 1000}s;

  .brightcove-react-player-loader .video-js {
    padding-top: 0;
  }
  &.hidden-img {
    height: 0px;
  }
`;
const MapContainer = styled_components_1.default.div `
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;

  margin-top: 16px;
  .g-maps-container {
    width: 100%;
  }
`;
const ContactContainer = styled_components_1.default.div `
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const DocumentTitle = styled_components_1.default.p `
  background-color: ${(props) => props.isDocumentImage ? "black" : "rgb( 50, 54, 57 )"};
  margin: 0;
  color: white;
  padding: 20px 100px 20px 16px;
`;
const EXPANSION_DURATION = 600;
// eslint-disable-next-line complexity
const DirectoryAndOfferDetailsModal = (props) => {
    var _a;
    const { activeItem, history, location, onClose, currentLocale, itemsInCart, setItemsInCart, setShowDiscardShoppingCartDialog, showDiscardShoppingCartDialog, setIsOpen, orderCompleted, setOrderCompleted, } = props;
    const [imageIsHidden, setImageIsHidden] = (0, react_1.useState)(false);
    const [showBookingForm, setShowBookingForm] = (0, react_1.useState)(false);
    const [showBookingLinkout, setShowBookingLinkout] = (0, react_1.useState)(false);
    const [toast, setToast] = (0, react_1.useState)("");
    const [showMap, setShowMap] = (0, react_1.useState)(false);
    const [showPhone, setShowPhone] = (0, react_1.useState)(false);
    const [showEmail, setShowEmail] = (0, react_1.useState)(false);
    const [showShoppingCart, setShowShoppingCart] = (0, react_1.useState)(false);
    const [clickFromCollapseBtn, setClickFromCollapseBtn] = (0, react_1.useState)(false);
    const [showVideo, setShowVideo] = (0, react_1.useState)(true);
    const isLinkoutBooking = (_a = activeItem === null || activeItem === void 0 ? void 0 : activeItem.availability) === null || _a === void 0 ? void 0 : _a.linkoutBooking;
    (0, react_1.useEffect)(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const shouldOpenBookingLinkout = searchParams.get('status') === 'success';
        if (!shouldOpenBookingLinkout || !isLinkoutBooking) {
            return;
        }
        setImageIsHidden(true);
        setShowVideo(false);
        setShowMap(false);
        setShowPhone(false);
        setShowEmail(false);
        setShowShoppingCart(false);
        setShowBookingForm(false);
        setShowBookingLinkout(true);
        searchParams.delete('status');
        const nextSearch = searchParams.toString();
        window.history.replaceState({}, '', `${window.location.pathname}${nextSearch ? `?${nextSearch}` : ''}`);
    }, [isLinkoutBooking]);
    const hideImage = () => {
        if (activeItem.videos && activeItem.videos.length > 0) {
            setImageIsHidden(true);
            setTimeout(() => {
                setShowVideo(false);
            }, EXPANSION_DURATION);
            return;
        }
        setImageIsHidden(true);
    };
    const hideToast = () => {
        setToast("");
    };
    const isRegularContent = activeItem.type !== "recipe" &&
        activeItem.type !== "website" &&
        activeItem.type !== "document" &&
        activeItem.type !== "folder";
    const isBookable = isRegularContent && activeItem.bookable && activeItem.availability;
    const isDocument = activeItem.type === "document";
    const isWebsite = activeItem.type === "website";
    const redirectLocation = activeItem.deeplink
        ? new URL(activeItem.deeplink).pathname
        : `/directory/page/${activeItem.title.toLowerCase().replace(/ /g, "-")}`;
    const showBookingPage = () => {
        history.push({
            pathname: `${redirectLocation}`,
            search: location.search,
        });
    };
    const showDevButton = window.location.search.includes("dev-mode=true");
    const locale = activeItem.locale ? activeItem.locale : currentLocale;
    const renderEmail = () => (react_1.default.createElement(ContactContainer, null, activeItem && activeItem.email && (react_1.default.createElement(CallToActionArea_1.default, { mainText: activeItem.email, secondaryText: i18n_js_1.default.t("dictionary.handover.email_message", {
            locale,
        }), qrValue: activeItem.email }))));
    const renderPhone = () => (react_1.default.createElement(ContactContainer, null, activeItem && activeItem.phone && (react_1.default.createElement(CallToActionArea_1.default, { mainText: activeItem.phone, secondaryText: i18n_js_1.default.t("dictionary.handover.call_message", { locale }), qrValue: activeItem.phone }))));
    const renderMapContent = () => (react_1.default.createElement(MapContainer, null, activeItem && (react_1.default.createElement(Map_1.default, { selectedVenue: activeItem }))));
    const renderBookingForm = () => (react_1.default.createElement(BookingForm_1.default, { activeItem: { content: activeItem, type: activeItem.type }, walkinRegistration: false }));
    const renderBookingLinkout = () => (react_1.default.createElement(BookingLinkoutView_1.default, { content: activeItem }));
    const renderMainContent = () => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "statuses-location-wrapper" },
            activeItem.placeName && (react_1.default.createElement(LocationComp, null,
                react_1.default.createElement(Place_1.default, null),
                react_1.default.createElement(Typography_1.default, { variant: "body2" }, activeItem.placeName))),
            react_1.default.createElement("div", null, (0, ActivityListItem_1.renderBookingAvailability)(activeItem))),
        react_1.default.createElement(CallToActionsInModal_1.default, { activeItem: { content: activeItem, type: activeItem.type }, openMap: () => {
                setShowMap(true);
                hideImage();
            }, openPhone: () => {
                setShowPhone(true);
                hideImage();
            }, openEmail: () => {
                setShowEmail(true);
                hideImage();
            } }),
        react_1.default.createElement(Description, { dangerouslySetInnerHTML: {
                __html: activeItem.text || null,
            } }),
        showDevButton && (react_1.default.createElement("button", { onClick: () => {
                showBookingPage();
                onClose();
            }, className: "dev-btn" },
            " ",
            "Dev Btn: Go to Deeplink"))));
    const handleClick = () => {
        hideImage();
        if (isLinkoutBooking) {
            return setShowBookingLinkout(true);
        }
        if (activeItem && activeItem.shoppingCartCatalogId !== null) {
            return setShowShoppingCart(true);
        }
        return setShowBookingForm(true);
    };
    const renderButton = () => isBookable && (react_1.default.createElement(BookBtn, null,
        react_1.default.createElement(material_1.Button, { onClick: () => {
                handleClick();
            }, variant: "contained", fullWidth: true }, activeItem.availability.textsForDisplay.bookButton)));
    const renderDocument = () => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(DocumentDetail_1.default, { documentData: activeItem }),
        showDevButton && (react_1.default.createElement("button", { onClick: () => {
                showBookingPage();
                onClose();
            }, className: "dev-btn" },
            " ",
            "Dev Btn: Go to Deeplink"))));
    const renderWebsite = () => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(WebsiteDetail_1.default, { websiteData: activeItem }),
        showDevButton && (react_1.default.createElement("button", { onClick: () => {
                showBookingPage();
                onClose();
            }, className: "dev-btn" },
            " ",
            "Dev Btn: Go to Deeplink"))));
    const renderShoppingCart = () => (react_1.default.createElement(react_1.default.Fragment, null, activeItem && (react_1.default.createElement(ShoppingCartRedesign_1.default, { activeItem: { content: activeItem, type: activeItem.type }, setShowBookingForm: setShowBookingForm, setItemsInCart: setItemsInCart, setShowDiscardShoppingCartDialog: setShowDiscardShoppingCartDialog, showDiscardShoppingCartDialog: showDiscardShoppingCartDialog, onClose: onClose, setIsOpen: setIsOpen, setShowShoppingCart: setShowShoppingCart, clickFromCollapseBtn: clickFromCollapseBtn, setClickFromCollapseBtn: setClickFromCollapseBtn, setImageIsHidden: setImageIsHidden, orderCompleted: orderCompleted, setOrderCompleted: setOrderCompleted, setShowVideo: setShowVideo }))));
    const imageHiddenClass = imageIsHidden ? "hidden-img" : "";
    const imgUrl = activeItem &&
        activeItem.images &&
        activeItem.images[0] &&
        activeItem.images[0]["2:1"] &&
        activeItem.images[0]["2:1"].L
        ? `url( ${activeItem.images[0]["2:1"].L} )`
        : null;
    const iconUrl = activeItem &&
        activeItem.icon &&
        activeItem.icon["2:1"] &&
        activeItem.icon["2:1"].L
        ? `url( ${activeItem.icon["2:1"].L} )`
        : null;
    const showCloseIcon = !showMap &&
        !showBookingForm &&
        !showBookingLinkout &&
        !showShoppingCart &&
        !showPhone &&
        !showEmail;
    const isDocumentPDF = isDocument && activeItem.contentType === "application/pdf";
    const isDocumentImage = isDocument && activeItem.contentType.includes("image");
    const modalContent = (react_1.default.createElement(react_1.Fragment, null,
        activeItem.videos && activeItem.videos.length > 0 ? (react_1.default.createElement(VideoWrapper, { expansionDuration: EXPANSION_DURATION, className: `${imageHiddenClass}` }, showVideo && (react_1.default.createElement(VideoPlayer_1.default, { expansionDuration: EXPANSION_DURATION, className: `${imageHiddenClass} `, video: activeItem.videos[0] })))) : (react_1.default.createElement(ImageWrapper, { expansionDuration: EXPANSION_DURATION, className: `${imageHiddenClass}` },
            react_1.default.createElement(ItemImage, { className: `item-image ${imageHiddenClass}`, expansionDuration: EXPANSION_DURATION, src: imgUrl || iconUrl }))),
        react_1.default.createElement("div", { className: "description-content" },
            react_1.default.createElement(ContentTitle, { className: "title" },
                react_1.default.createElement(Typography_1.default, { variant: "h5" }, activeItem.title)),
            react_1.default.createElement("div", { className: "scrollable-content" }, (() => {
                if (isDocument) {
                    return renderDocument();
                }
                if (isWebsite) {
                    return renderWebsite();
                }
                if (showMap) {
                    return renderMapContent();
                }
                if (showPhone) {
                    return renderPhone();
                }
                if (showEmail) {
                    return renderEmail();
                }
                if (showBookingForm) {
                    return renderBookingForm();
                }
                if (showBookingLinkout) {
                    return renderBookingLinkout();
                }
                if (showShoppingCart) {
                    return renderShoppingCart();
                }
                return renderMainContent();
            })())),
        (() => {
            if (!showMap &&
                !showPhone &&
                !showEmail &&
                !showBookingForm &&
                !showBookingLinkout &&
                !isDocument &&
                !isWebsite &&
                !showShoppingCart) {
                return renderButton();
            }
            return null;
        })()));
    const modalDocumentContent = (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(DocumentTitle, { isDocumentImage: isDocumentImage }, activeItem.title),
        isDocumentPDF && (activeItem === null || activeItem === void 0 ? void 0 : activeItem.dataUrl) && (react_1.default.createElement("iframe", { title: activeItem.title, src: helpers_1.Helpers.isMobile.Android() || helpers_1.Helpers.isMobile.iOS()
                ? `https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(activeItem.dataUrl)}`
                : activeItem.dataUrl, width: "100%", height: "100%" })),
        isDocumentImage && (react_1.default.createElement("div", { className: "image-container" },
            react_1.default.createElement("img", { src: activeItem.dataUrl, alt: "modal-img" })))));
    return (react_1.default.createElement(ItemDetailModalContentWrapper, { contentWidth: globalVariables_1.WEB_APP.MODAL_WIDTH, contentModalBP: globalVariables_1.WEB_APP.SHOW_CONTENT_AS_MODAL_BP, className: isDocumentPDF || isDocumentImage ? "document-modal" : "" },
        isDocumentPDF && showCloseIcon && (react_1.default.createElement(IconButton_1.default, { className: `open-btn ${showCloseIcon ? "" : "dark"}`, sx: { right: 137 }, onClick: () => {
                if (activeItem === null || activeItem === void 0 ? void 0 : activeItem.dataUrl) {
                    window.open(activeItem.dataUrl, "_blank");
                }
            } },
            react_1.default.createElement(OpenInNew_1.default, null))),
        showCloseIcon && (react_1.default.createElement(IconButton_1.default, { className: `copy-btn ${showCloseIcon ? "" : "dark"}`, sx: { right: 77 }, onClick: () => {
                setToast(i18n_js_1.default.t("link_copied_to_clipboard"));
                navigator.clipboard.writeText(activeItem.deeplink);
            } },
            react_1.default.createElement(ContentCopy_1.default, null))),
        react_1.default.createElement(IconButton_1.default, { "aria-label": "close", className: `collapse-btn ${showCloseIcon ? "" : "dark"}`, onClick: () => {
                setClickFromCollapseBtn(true);
                if ((showMap ||
                    showPhone ||
                    showEmail ||
                    showBookingForm ||
                    showBookingLinkout ||
                    showShoppingCart) &&
                    !itemsInCart) {
                    setImageIsHidden(false);
                    setShowMap(false);
                    setShowPhone(false);
                    setShowEmail(false);
                    setShowBookingForm(false);
                    setShowBookingLinkout(false);
                    setShowShoppingCart(false);
                    setShowVideo(true);
                }
                else {
                    onClose();
                }
                if (orderCompleted) {
                    setImageIsHidden(false);
                    setShowVideo(true);
                }
                if (!showCloseIcon && itemsInCart) {
                    setShowDiscardShoppingCartDialog(true);
                }
            }, sx: { right: 17 } }, showCloseIcon ? react_1.default.createElement(Close_1.default, null) : react_1.default.createElement(KeyboardDoubleArrowDown_1.default, null)),
        isDocumentPDF || isDocumentImage ? modalDocumentContent : modalContent,
        react_1.default.createElement(material_1.Snackbar, { onClose: hideToast, autoHideDuration: 4000, open: Boolean(toast), message: toast, anchorOrigin: {
                vertical: "bottom",
                horizontal: "center",
            }, className: "snackbar", action: react_1.default.createElement(ContentCopy_1.default, { fontSize: "small" }) })));
};
exports.DirectoryAndOfferDetailsModal = DirectoryAndOfferDetailsModal;
const mapStoreToProps = (store) => ({
    itemDetailIsShown: store.getValue("itemDetailIsShown"),
    pausedByInteraction: store.getValue("pausedByInteraction"),
    currentLocale: store.getValue("currentLocale"),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(exports.DirectoryAndOfferDetailsModal));
